export default __webpack_public_path__ + "static/media/esaudito.65af4dfc.png";